import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    beforeSend(event) {
      if (event.request?.headers) delete event.request.headers.authorization;
      if (event.request?.headers) delete event.request.headers.cookie;
      return event;
    },
  });
}

const rootElement = document.getElementById('root');
const tree = (
  <HelmetProvider>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong. Please refresh.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </HelmetProvider>
);

// react-snap prerenders each route; when the browser hydrates, `rootElement`
// already has children — use hydrateRoot then. Fall back to createRoot for
// dev + first-ever loads.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(tree);
}
